
// This is an auto generated file - do not edit!
// Swagger path: /api/IdentityCheckResult/{id}/actions

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    EntityAction
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class IdentitycheckresultIdActionsApiService extends BaseApiService {
    
    get(id: string, options = {}): Observable<EntityAction[]> {
        return this._get<EntityAction[]>(
            `/IdentityCheckResult/${id}/actions`,
            options
        );
    }
}
